import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './brand/brand.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Notification from "./components/Notification";

ReactDOM.render(
  <Router>
    <App />
    <Notification />
  </Router>,
  document.getElementById('root')
);
